<script lang="ts" setup>
  const model = defineModel<boolean>({ required: true })

  function toggleSwitch(): void {
    model.value = !model.value
  }

</script>

<template>
  <div
    class="c-switch-input"
    :class="{ active: model }"
    @click="toggleSwitch"
  >
    <div class="bg" />
    <div class="slider" />
  </div>
</template>

<style scoped>

.c-switch-input {
  position: relative;
  width: 34px;
  height: 14px;
  cursor: pointer;

  .bg {
    width: 100%;
    height: 100%;
    border-radius: 20px;
    background-color: var(--color-secondary);
    opacity: 0.2;
    transition: all ease 0.15s;
  }

  .slider {
    position: absolute;
    top: -3px;
    left: -3px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: var(--color-secondary);
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 21%);
    transition: all ease 0.15s;
  }

  &.active {
    .bg {
      background-color: var(--color-primary);
      opacity: 1;
    }

    .slider {
      left: 17px;
    }
  }
}
</style>
